import React, { useEffect, useRef, useState, FunctionComponent } from "react";
import { PackBottom } from "@/components/responsive/product/pack/packBottom/PackBottom";
import { PackSlider } from "@/components/responsive/product/pack/packSlider/PackSlider";
import { ProductLinkedPack } from "@/models/scope/productSheet/ProductLinkedPack";
import { ProductPackItem } from "@/models/scope/productSheet/ProductPackItem";
import Utils from "@/libs/Utils";

interface Props {
  linkedPacks: ProductLinkedPack[];
  packItems: ProductPackItem[];
  isMobile: boolean;
  handleOpenLayer: (layerType: string, selectedProductId?: string) => void;
  trackingData: {}
}

export const Pack: FunctionComponent<Props> = ({ linkedPacks, packItems, isMobile, handleOpenLayer, trackingData }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);

  const isPack: boolean = !linkedPacks.length && packItems.length > 0;
  let explodedPackItems: ProductPackItem[] = []
  if (isPack) {
    packItems.forEach(function (item, i) {
      for (let index = 0; index < Number(item.quantity); index++) {
        explodedPackItems.push(item)
      }
    });
  }

  useEffect(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [isMobile]);

  return !isPack ? (
    <div className="pack" ref={ref}>
      <hr />
      <p className="title">Existe aussi en pack</p>
      {linkedPacks.map((group, index) =>
        <div className="group" key={index}>
          <p className="subtitle">{`Pack ${group.packItems.length} éléments`}</p>
          <PackSlider items={group.packItems} width={width} isMobile={isMobile} noDivider={index === linkedPacks?.length - 1} urlBundle={Utils.getMetaInfosValueByCode("sheetUrl", group.metaInfos)}>
            {!!group.price ? (
              <PackBottom
                handleOpenLayer={handleOpenLayer}
                price={group.price}
                crossedOutPrice={group.crossOutPrice}
                productId={group.id}
               trackingData={trackingData}/>
            ) : <></>}
          </PackSlider>
        </div>
      )}
    </div>
  ) : (
    <div className="pack" ref={ref}>
      <hr />
      <p className="title">Composition du pack</p>
      <div className="group">
        <PackSlider items={explodedPackItems} width={width} isMobile={isMobile} />
      </div>
    </div>
  );
};